import { LOCALES } from '../locales';

 const EnglishLanguage =  {
    [LOCALES.ENGLISH]: {
        'hello': 'Hello',
        'homepage': 'Homepage',
        'username' : 'Username',
        'password' : 'Password',
        'newpassword' : ' New passowrd  ',
        'confirm-newpassword' : ' Confirm new passowrd     ',
        "bisharat" : 'Bisharat',
        'email' : "Email",
        'phone-num' : 'Phone Number ',
        'new-phone-num' : ' New phone number   ',
        'full-name' : ' Full Name ',
        'bisharatfamily':'Bisharat Family',
        'permissions' : 'Permissions',
        'familytree':'Family Tree',
        'loading-family-tree':'Loading family tree...',
        'gallery':'Gallery',
        'historical-info':'  Historical Information  ',
        'about-us':'   About Us  ',
        'login':'Login',
        'login-now':' Login ',
        'logout':'Logout',
        'already-logged' : 'Already Logged In   ',
        'click-to-activate' : '  Click to activate your account',
        'activated' : 'Account activated successfully',
        'not-activated' : ' Account activation failed ',
        'adminboard' : 'Admin Board ',
        'user-pass-incorrect' : "Incorrect username or password ",
        'my-profile' : "My Profile ",
        'for-more-contact' : 'For more information, Please contact us',
        'contact-us' : "Contact us  ",
        'click-here' : "Click here  ",
        'read-more' : "    Read more   ",
        'specify' : ' Please specify',
        "send" : 'Send',
        'alert-email-sent' : 'Mail will be sent to your email to activate your account',
        'email-not-validated' : 'Email is not validated',   
        'mail-sent-success' : ' Email sent successfully   ',
        'username-not-validated' : 'Username could not contain spaces',
        'username-not-available' : 'Username is not  appropriate',
        'name-not-appropriate' : 'Name is not appropriate',
        'not-appropriate' : 'Field not appropriate ',
        'password-not-appropriate' : 'Password is not appropriate',
        'password-more-than-8' : 'Password must contain more than 8 letters',
        'numbers-only' : 'Only Numbers',
        'phone-10-digits' : 'Cellular number is 10 digits',
        'phone-example' : 'Example : 0505123123',
        'some-instructions' : 'Tips & Instructions for better family tree view ',
        'members-entrance' : '  Entrance allowed only with family member permissions',  
        'use-chrome' : ' Chrome explorer preffered ',
        'scroll-sides' : ' Scroll Left/Right to see full tree ',
        'click-to-open' : ' Click on person to open profile  ',
        'see-full-profile' : 'There is option to view tree starting from specific person through it"s profile',
        'add-partner-succesfully' : 'Add Partner Completed Successfully',
        'last-update' : ' Last update',
        'next-update' : '    Next update',
        'maaloul-village' : "Ma'aloul Village",
        'maaloul-village-zochrot' : "  Ma'aloul from Zochrot.org  ",
        'click-to-download-book' : "Click here to Read/Download booklet",
        'welcome' : "Welcome",
        'mandatory' : " Mandatory field",
        'join-now' : "Join now",
        'join' : 'Signup',
        "request-permission-bish" : "Please go to 'My Profile' and request family permission for watching family tree and other contents. ",
        'msg-subject' : 'Message subject',
        'msg-content' : '  Message content',
        "activities" : "Celebrations and Activities",
        'notifications' : "Notifications",
        'site-under-development': "This site still new and under development.",
        'welcoming-suggestions' : "Feel free to suggest new ideas",
        "too-much-tries" : " too much tries without sucess  - please contact us to activate your account",
        "too-much-tries-change-number" : " too much tries without sucess  - please contact us",
        "number-changed-successfully" : " Phone number changed successfully ",
        "User-phone-confirmed" : "Phone confirmed successfully.. The system is checking your identity for family permission",
        "back-to-main" : 'Back to homepage ',
        'pagenotfound' : 'Page Not Found  ',
        'back' : 'Back',
        "request-family-permissions" : 'Request Family Permissions',
        "family-per-content" : "This content need family permissions",
        "restore-user-pass" : 'Retore Username or Password',
        'check-ur-namil' : 'Check your mail to activate your account ',
        "maaloul-parag-first" : "It is a Palestinian village located 12 kilometers west of Nazareth and about 30 kilometers southwest of Haifa, and two kilometers north of the village of Al-Mujaidil, separated by a main road linking Haifa and Nazareth, and it was a secondary road linking Maaloul to the main road. Ma’alul is a Canaanite word meaning “entrance or gate.” It is believed that it was erected above the place where the Roman Ahlul or Mahloul was based, and it was affiliated at the time to Saffuriyya, and the Crusaders knew it as Ma’oula.",
        "maaloul-parag-second" : "Maaloul was established in the southern part of the Lower Galilee Mountains, 270 meters above sea level. Wadi al-Halabi or al-Safsaf, located in its southwest, separates its lands from the lands of al-Mujaidil village. Ain al-Bass is located in its north-east and Ain al-Balad in its north-west.",
        'check-sms-req' : "Thanks, checking your permission request ",
        'code' : 'Verification Code',
        'verify-code' : 'Confirm verification code  ',
        'tries' : 'tries',
        "youve" : "You've",
        'changepassword' : ' Change password  ',
        'modifyphone' : '   Modify number ',
        'newphone-used' : 'Number already used  ',
        'checkphone' : 'Check your phone number before sending family permission request ',
        // 'sendsms': ' Verification SMS will be sent to verify your account   ',
        'sendsms': 'You will receive a one-time verification code to your phone number by SMS. Message and data rates may apply.',
        'oldpass-notcorrect' : 'Passowrd is not correct   ',
        'newpass-notsimilar' : 'Password is not confirmed  ',
        'success-change-pass' : 'Passowrd changed successfully',
        'link-unavailable' : 'Unavailable link',
        'notif' : 'Notification',
        'publishdate' : ' Publish date',
        'moredetails' : 'More details',
        'activity' : 'Activity',
        "activity-link" : 'Activity link',
        "activity-date" : ' Activity date   ',
        "this-day-activity" : 'This Day Activity',
        'pick-date-act' : 'Pick date to see its activities',
        "oncoming-act" : 'Oncoming activities',
        "name" : "Name",
        "father-name" : 'Father Name ',
        "mother-name" : 'Mother Name ',
        "family-name" : 'Family Name ',
        "address" : 'Address',
        "partner" : 'Partner',
        'children' : 'Children',
        "showPartner" : 'Partners Profile',
        "addPartner" : ' Add Partner',
        "birthdate" : 'Birthdate ',
        "gender" : 'Gender',
        'notfound' : 'No data provided ',
        'fa-tree-person' : "Person's Tree  ",
        "edit" : 'Edit',
        "add-child" : 'Add child ',
        "profile-pic" : 'Profile Picture ',
        "edit-profile-pic" : 'Edit Profile Picture ',
        "alive" : "Alive?  ",
        "yes" : 'Yes',
        "no" : 'No',
        "married" : "Married",
        "not-married" : "Not married ",
        "status-fam" : ' Marital Status ',
        'identity' : ' Identity',
        "male" : 'Male',
        "female" : 'Female',
        'thanks-for-donation' : 'Thanks a lot',
        'donation-text' : 'will continue growing with your support ',
        
    }
}
export default EnglishLanguage;